import { MODALSEGUNDO_HIDE, MODALSEGUNDO_SHOW, RESET_PORTAL_CONTEXT } from "../ActionTypes";

import segundoModalInitialState from "../initialStates/segundoModalInitialState";

const segundoModal = (state, { payload, type }) => {
  switch (type) {
    case MODALSEGUNDO_HIDE:
      return segundoModalInitialState;
    case RESET_PORTAL_CONTEXT:
      return segundoModalInitialState;
    case MODALSEGUNDO_SHOW:
      return {
        segundoModal: {
          show: true,
          data: payload,
        },
      };
    default:
      return state;
  }
};

export default segundoModal;
